import Financial from "../../modules/financial/view/Financial.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import { PermissionList } from "../../static-data/PermissionList";
import { IsAbleNavigation } from "../utils/is-able-navigation";
import Analytics from "../../modules/analytics/views/Analytics.vue";
import ReportIncome from "../../modules/report-income/views/ReportIncome.vue";
import SustainabilityFund from "../../modules/sustainability-fund/views/SustainabilityFund.vue";
import QuotaStatement from "../../modules/quota-statement/views/QuotaStatement.vue";
import IncomeHistory from "../../modules/income-history/views/IncomeHistory.vue";
import ReportVoxis from "../../modules/voxis/view/ReportVoxis.vue";
import BackbeatView from "../../modules/backbeat/views/BackbeatView.vue";
import BackbeatKnowMore from "../../modules/backbeat/views/BackbeatKnowMoreView.vue";
import ReviewGlossesView from "../../modules/review-glosses/views/ReviewGlossesView.vue";
import AnnuityRefund from "../../modules/annuity-refund/views/AnnuityRefund.vue";
import ProductionManagement from "../../modules/production-management/views/ProductionManagement.vue";


const FinancialRoutes = {
  path: "financeiro",
  component: RouterViewRender,
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.FINANCIAL_MENU),
  children: [
    {
      path: "",
      component: Financial,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "analitica",
      component: Analytics,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "gestao-de-producao",
      component: ProductionManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "historico-notas-fiscais",
      component: IncomeHistory,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "backbeat",
      component: BackbeatView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "backbeat-saiba-mais",
      component: BackbeatKnowMore,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "recurso-glosas",
      component: ReviewGlossesView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "informe-rendimentos",
      component: ReportIncome,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "fundo-sustentabilidade",
      component: SustainabilityFund,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "cota-capital",
      component: QuotaStatement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "relatorio-glosas-voxis",
      component: ReportVoxis,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "reembolso-anuidade",
      component: AnnuityRefund,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default FinancialRoutes;
